import Table, { TablePaginationConfig, TableProps } from './Table';
export { ColumnProps } from './Column';
export { ColumnGroupType, ColumnsType, ColumnType } from './interface';
export { TableProps, TablePaginationConfig };
export default Table;
